import type { FileViewOverride } from "@/shared/components/DatasetFileGrid/DatasetGridItem";
import { type FileRecord } from "@/shared/domain/files";
import { FileSystemNode } from "@/shared/domain/files/filesystem";
import { assetSourceToIngest } from "@/shared/domain/urdf";

/**
 * Makes the file grid open ingestable sources (robot descriptions and point
 * cloud scans) in the ingest wizard instead of navigating to them.
 *
 * The grid knows nothing about ingestable sources, so the file browser supplies
 * this override. It is its own module so a unit test can check which files it
 * accepts without mounting a grid.
 *
 * @param onIngestAsAsset opens the ingest wizard, or `undefined` where the file
 *   browser offers no ingestion. Then there is no override, and the grid
 *   navigates to every node.
 */
export function assetFileViewOverride(
  onIngestAsAsset: ((file: FileRecord) => void) | undefined,
): FileViewOverride | undefined {
  if (onIngestAsAsset === undefined) {
    return undefined;
  }
  return {
    accepts: (node: FileSystemNode) => assetSourceToIngest(node) !== null,
    view: (node: FileSystemNode) => {
      const toIngest = assetSourceToIngest(node);
      if (toIngest !== null) {
        onIngestAsAsset(toIngest);
      }
    },
  };
}
